<template>
  <section class="visualization-years">
    <div class="visualization-controls__select">
      <label for="beginYear">Start Year:</label>
      <multiselect
        :options="beginYears"
        :show-labels="false"
        :value="beginYear"
        track-by="value"
        label="label"
        @input="updateBeginYear"
      >
        <template slot="option" slot-scope="props">
          <div class="option__value">
            {{ props.option.value }}
          </div>
        </template>
      </multiselect>
    </div>

    <div class="visualization-controls__select">
      <label for="endYear">End Year:</label>
      <multiselect
        :options="endYears"
        :show-labels="false"
        :value="endYear"
        track-by="value"
        label="label"
        @input="updateEndYear"
      >
        <template slot="option" slot-scope="props">
          <div class="option__value">
            {{ props.option.value }}
          </div>
        </template>
      </multiselect>
    </div>
  </section>
</template>

<script>
import { mapMutations } from "vuex";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },

  computed: {
    beginYear() {
      const val = this.$store.state.visualization.beginYear;
      return { label: val, value: val };
    },
    endYear() {
      const val = this.$store.state.visualization.endYear;
      return { label: val, value: val };
    },
    beginYears() {
      const end = this.$store.state.visualization.endYear;
      const allYearLabels = this.$store.state.visualization.allYearLabels;
      const lastYear = allYearLabels[allYearLabels.length - 1];
      let beginYearOptions = allYearLabels.map((y) => {
        if (end < y) {
          return { label: y, value: y, $isDisabled: true };
        }
        return { label: y, value: y };
      });
      if (beginYearOptions?.length) {
        beginYearOptions.pop();
      }
      return beginYearOptions;
    },
    endYears() {
      const begin = this.$store.state.visualization.beginYear;
      const allYearLabels = this.$store.state.visualization.allYearLabels;
      const endYearOptions = allYearLabels.map((y) => {
        if (begin >= y) {
          return { label: y, value: y, $isDisabled: true };
        }
        return { label: y, value: y };
      });
      return endYearOptions.reverse();
    },
  },

  methods: {
    ...mapMutations({
      setBeginYear: "visualization/setBeginYear",
      setEndYear: "visualization/setEndYear",
    }),
    updateBeginYear(value) {
      if (!value) {
        let val = event.currentTarget
          .querySelector(".option__value")
          ?.textContent?.trim();
        if (val) {
          this.setBeginYear(Number(val));
        }
      } else {
        this.setBeginYear(value.value);
      }
      this.$emit("child-changed", true);
    },
    updateEndYear(value) {
      if (!value) {
        let val = event.currentTarget
          .querySelector(".option__value")
          ?.textContent?.trim();
        if (val) {
          this.setEndYear(Number(val));
        }
      } else {
        this.setEndYear(value.value);
      }
      this.$emit("child-changed");
    },
  },
};
</script>

<style lang="scss">
.visualization-years {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  & > div {
    margin-top: 0.5rem;
  }
}
</style>
